import { ConfirmImportRequest } from "../contracts/ConfirmImportRequest";
import { ImportProposal } from "../models/ImportProposal";

/** Maps the reviewed frontend proposal back to the confirm request contract */
export class ConfirmImportRequestMapper {
  toConfirmImportRequest = (proposal: ImportProposal): ConfirmImportRequest => {
    return {
      members: proposal.members.map((member) => ({
        tempId: member.tempId,
        firstName: member.firstName,
        lastName: member.lastName,
        email: member.email,
        notes: member.notes,
      })),
      groups: proposal.groups.map((group) => ({
        tempId: group.tempId,
        name: group.name,
        memberTempIds: group.memberTempIds,
      })),
      sessions: proposal.sessions.map((session) => ({
        tempId: session.tempId,
        title: session.title,
        weekdays: session.weekdays,
        timeLocal: session.timeLocal,
        durationMinutes: session.durationMinutes,
        memberTempIds: session.memberTempIds,
        groupTempIds: session.groupTempIds,
      })),
    };
  };
}
